import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";

export function useAllFeedTypesForExternalFeeds() {
    return useOctopusFeatureToggle("external-release-trigger-all-feeds", false);
}
